/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Phone
 */
export interface Phone {
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    areaCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    number?: string | null;
}

export function PhoneFromJSON(json: any): Phone {
    return PhoneFromJSONTyped(json, false);
}

export function PhoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): Phone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'areaCode': !exists(json, 'areaCode') ? undefined : json['areaCode'],
        'number': !exists(json, 'number') ? undefined : json['number'],
    };
}

export function PhoneToJSON(value?: Phone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countryCode': value.countryCode,
        'areaCode': value.areaCode,
        'number': value.number,
    };
}


